import React from 'react';
import classnames from 'classnames';

import { Portal } from '../portal/Portal';
import WpBackdrop from '../backdrop/WpBackdrop';

import './WpDrawer.scss';

type Orientation = 'top' | 'bottom' | 'left' | 'right';
const DEFAULT_ORIENTATION = 'bottom';

export interface Props {
  orientation?: Orientation;
  isOpen: boolean;
  children?: React.ReactNode;
  zIndex?: number;
  onToggle?(): void;
  context?: any;
}

const classNamePrefix = 'WpDrawer';

const WpDrawer: React.FC<Props> = ({
  orientation = DEFAULT_ORIENTATION,
  isOpen = false,
  children,
  onToggle,
  zIndex,
  context,
}: Props) => {
  const classes = classnames(classNamePrefix, `${classNamePrefix}--orientation-${orientation}`, {
    [`${classNamePrefix}--open`]: isOpen,
  });

  return (
    <Portal idPrefix="drawer">
      <div className={classes} ref={context?.refs?.setFloating}>
        <div className={`${classNamePrefix}__content`} style={{ zIndex }}>
          {isOpen ? children : null}
        </div>
        <WpBackdrop onClick={onToggle} />
      </div>
    </Portal>
  );
};

export default WpDrawer;
